var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlayDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.5 28C0.5 20.5739 3.44999 13.452 8.70101 8.20101C13.952 2.94999 21.0739 0 28.5 0C35.9261 0 43.048 2.94999 48.299 8.20101C53.55 13.452 56.5 20.5739 56.5 28C56.5 35.4261 53.55 42.548 48.299 47.799C43.048 53.05 35.9261 56 28.5 56C21.0739 56 13.952 53.05 8.70101 47.799C3.44999 42.548 0.5 35.4261 0.5 28ZM21.0953 16.0891C20.2641 16.5484 19.75 17.4344 19.75 18.375V37.625C19.75 38.5766 20.2641 39.4516 21.0953 39.9109C21.9266 40.3703 22.9328 40.3594 23.7531 39.8562L39.5031 30.2312C40.2797 29.75 40.7609 28.9078 40.7609 27.9891C40.7609 27.0703 40.2797 26.2281 39.5031 25.7469L23.7531 16.1219C22.9437 15.6297 21.9266 15.6078 21.0953 16.0672V16.0891Z",
    fill: "url(#paint0_linear_305_523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.7419 16.1328C22.9325 15.6406 21.9153 15.6187 21.0841 16.0781C20.2528 16.5375 19.7388 17.4234 19.7388 18.3641V37.625C19.7388 38.5766 20.2528 39.4516 21.0841 39.9109C21.9153 40.3703 22.9216 40.3594 23.7419 39.8562L39.4919 30.2312C40.2685 29.75 40.7497 28.9078 40.7497 27.9891C40.7497 27.0703 40.2685 26.2281 39.4919 25.7469L23.7419 16.1219V16.1328Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_523",
    x1: 0.960548,
    y1: 56,
    x2: 67.7657,
    y2: 28.7887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-play-duotone-solid.1369f81bdd37b1460f4711f337720e31.svg";
export { ForwardRef as ReactComponent };